import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalService } from 'ng-devui';
import {
  TableColumnConfig,
  TableColumnType,
  TableConfig,
} from 'src/app/modules/shared/components/table-pro/table.config';
import { HostDirective } from 'src/app/modules/shared/directives/host.directive';
import { JgPhysicalInspUnitFxItemSearchRequest } from 'src/app/modules/shared/models/jg/jg-physical-insp-unit-fx-item-search-request.model';
import { JgVisualInspReportFileListRequest } from 'src/app/modules/shared/models/jg/jg-visual-insp-report-file-list-request.model';
import { JgVisualInspReportFile } from 'src/app/modules/shared/models/jg/jg-visual-insp-report-file.model';
import { JgVisualInspUnitFbDetail } from 'src/app/modules/shared/models/jg/jg-visual-insp-unit-fb-detail.model';
import { JgVisualInspUnitFbListRequest } from 'src/app/modules/shared/models/jg/jg-visual-insp-unit-fb-list-request.model';
import { JgVisualInspUnitFb } from 'src/app/modules/shared/models/jg/jg-visual-insp-unit-fb.model';
import { ProjectSectionListRequest } from 'src/app/modules/shared/models/project/project-section-list-request.model';
import { ProjectSection } from 'src/app/modules/shared/models/project/project-section.model';
import { OrganizationType } from 'src/app/modules/shared/models/staff/organization-type.enum';
import { NzTreeNode } from 'src/app/modules/shared/models/tree-node.model';
import { GlobalService } from 'src/app/modules/shared/providers/global.service';
import { OrderType } from 'src/app/modules/shared/providers/request/order-type.enum';
import { JgVisualInspReportFileService } from 'src/app/modules/shared/services/jg-visual-insp-report-file.service';
import { JgVisualInspUnitFbService } from 'src/app/modules/shared/services/jg-visual-insp-unit-fb.service';
import { ProjectSectionItemService } from 'src/app/modules/shared/services/project-section-item.service';
import { ProjectSectionService } from 'src/app/modules/shared/services/project-section.service';
import { DialogJgVisualReportUploadComponent } from '../../../dialogs/dialog-jg-visual-report-upload/dialog-jg-visual-report-upload.component';

@Component({
  selector: 'app-handover-insp-appear',
  templateUrl: './handover-insp-appear.component.html',
  styleUrls: ['./handover-insp-appear.component.scss'],
})
export class HandoverInspAppearComponent {
  @ViewChild(HostDirective, { static: true }) hiddenHost!: HostDirective;
  @ViewChild('scroll') scroll?: ElementRef<any>;

  config?: TableConfig = new TableConfig();

  mainRequest: JgPhysicalInspUnitFxItemSearchRequest =
    new JgPhysicalInspUnitFxItemSearchRequest();

  searchRequest: JgVisualInspUnitFbListRequest =
    new JgVisualInspUnitFbListRequest();

  pager = this.globalService.recoverPager();

  totalWidth = 0;
  scrollTop = 0;
  scrollIndex = 0;
  isOpen = true;

  reportList: JgVisualInspReportFile[] = [];

  recordList: JgVisualInspUnitFb[] = [];

  recordFakeTable: JgVisualInspUnitFb[] = [];

  recordTable: JgVisualInspUnitFb[] = [];

  cascaderOptions: NzTreeNode[] = [];

  cascaderValue: number[] = [];

  sectionList: ProjectSection[] = [];
  totalSum: number = 0;

  totalSumMap: { [key: string]: number } = {};

  get withToken() {
    return '?token=' + this.globalService.token;
  }

  get canWrite(): boolean {
    if (location.href.indexOf('#/open') > -1) {
      const query = window.location.href.split('?')[1] ?? '';
      const params = new URLSearchParams(query);
      return params.get('writeable') === 'true';
    }
    return this.globalService.writeAbleByUrl('/handover/appearance');
  }

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private projectSectionService: ProjectSectionService,
    private jgVisualInspUnitFbService: JgVisualInspUnitFbService,
    private jgVisualInspReportFileService: JgVisualInspReportFileService,
    private projectSectionItemService: ProjectSectionItemService,
    private globalService: GlobalService,
    private modalService: ModalService,
  ) {}

  ngOnInit(): void {
    this.getSectionList();
  }

  getSectionList() {
    this.projectSectionService
      .findAll<ProjectSectionListRequest>({
        projectId: this.globalService.projectId,
      })
      .subscribe((projectSections) => {
        this.sectionList = projectSections;
        this.buildSectionTree(projectSections);
      });
  }

  private buildSectionTree(res: ProjectSection[]) {
    const jgSectionIds: number[] = [];
    for (const section of this.globalService.userInfo.projectSections ?? []) {
      if (section.sectionType === OrganizationType.JG_CHECK) {
        jgSectionIds.push(section.sectionId!);
      }
    }
    if (jgSectionIds.length === 0) {
      this.sectionList = [];
      return;
    }
    const cSectionIds: number[] = [];
    if (
      this.globalService.userInfo.organizationType ===
      OrganizationType.CONSTRUCTION
    ) {
      for (const section of this.globalService.userInfo.projectSections ?? []) {
        if (section.sectionType === OrganizationType.CONSTRUCTION) {
          cSectionIds.push(section.sectionId!);
        }
      }
    }
    const jgSections = res.filter((s) => jgSectionIds.includes(s.id!));
    const treeNode: NzTreeNode[] = [];
    for (const section of jgSections) {
      const jgNode = {
        label: section.name!,
        value: section.id!,
        children: [] as NzTreeNode[],
      };
      for (const cSection of section.projectSectionSections ?? []) {
        if (cSection.refSectionType === OrganizationType.CONSTRUCTION) {
          if (
            this.globalService.userInfo.organizationType ===
            OrganizationType.CONSTRUCTION
          ) {
            if (!cSectionIds.includes(cSection.refSectionId!)) {
              continue;
            }
          }
          jgNode.children!.push({
            label: cSection.refSectionName!,
            value: cSection.refSectionId!,
            isLeaf: true,
          });
        }
      }
      if (jgNode.children!.length > 0) {
        treeNode.push(jgNode);
      }
    }
    this.cascaderOptions = treeNode;
    if (
      this.cascaderOptions.length > 0 &&
      this.cascaderOptions[0].children!.length > 0
    ) {
      this.cascaderValue = [
        this.cascaderOptions[0].value,
        this.cascaderOptions[0].children![0].value,
      ];
    }
    this.onSectionChange();
  }

  onSectionChange() {
    setTimeout(() => {
      this.mainRequest.jgSectionId = this.cascaderValue[0];
      this.mainRequest.sectionId = this.cascaderValue[1];
      this.mainRequest.projectId = this.globalService.projectId;
      this.getReportList();
      this.jgVisualInspUnitFbService
        .findAll<JgVisualInspUnitFbListRequest>({
          projectId: this.globalService.projectId,
          jgSectionId: this.mainRequest.jgSectionId,
          sectionId: this.mainRequest.sectionId,
        })
        .subscribe((res) => {
          console.log('res', res);
          this.initConfig(res);
        });
    }, 100);
  }

  getReportList() {
    this.jgVisualInspReportFileService
      .findAll<JgVisualInspReportFileListRequest>({
        projectId: this.globalService.projectId,
        jgSectionId: this.mainRequest.jgSectionId,
        sectionId: this.mainRequest.sectionId,
      })
      .subscribe((res) => {
        this.reportList = res;
      });
  }

  addReport() {
    const reportInit = new JgVisualInspReportFile();
    reportInit.projectId = this.globalService.projectId;
    reportInit.jgSectionId = this.mainRequest.jgSectionId;
    reportInit.sectionId = this.mainRequest.sectionId;
    const results = this.modalService.open({
      backdropCloseable: false,
      component: DialogJgVisualReportUploadComponent,
      onClose: () => {},
      data: {
        data: reportInit,
        onCancel: () => {
          results.modalInstance.hide();
        },
        onConfirm: () => {
          this.getReportList();
          results.modalInstance.hide();
        },
      },
    });
  }

  @HostListener('window:visibilitychange')
  handleVisibilityChange() {
    this.searchRecord();
    this.getReportList();
  }

  searchRecord() {
    this.jgVisualInspUnitFbService
      .search<JgVisualInspUnitFbListRequest>(
        this.searchRequest,
        this.pager.pageIndex - 1,
        1000,
      )
      .subscribe((data) => {
        this.globalService.savePager(this.pager);
        for (const item of data.content) {
          item.dwType = item.dwTypeName;
        }
        this.recordList = data.content
          .sort((a, b) => {
            if (a.dwTypeNameSort === b.dwTypeNameSort) {
              return this.searchRequest.dwCodeSortOrder !== OrderType.DESC
                ? a.dwCodeSort! - b.dwCodeSort!
                : b.dwCodeSort! - a.dwCodeSort!;
            }
            return a.dwTypeNameSort! - b.dwTypeNameSort!;
          })
          .filter((item) => {
            if (this.searchRequest.dwMileage) {
              return item.dwMileage?.includes(this.searchRequest.dwMileage);
            }
            return true;
          });
        this.recordTable = this.handleTable(
          JSON.parse(JSON.stringify(this.recordList)),
        );
        this.pager.total = data.totalElements;
        this.onScrollEnd();

        this.calculateFinalSum();
      });
  }

  queryPanelStateChange(isOpen: boolean) {
    console.log(isOpen);
    if (isOpen === false) {
      this.resetSearch();
    }
  }

  resetSearch() {
    this.searchRequest = JSON.parse(JSON.stringify(this.mainRequest));
    this.searchRequest.dwCodeSortOrder = OrderType.ASC;
    this.pager.pageIndex = 1;
    this.searchRecord();
  }

  private prepareSearch(data: any) {
    const searchRequest = new JgVisualInspUnitFbListRequest();
    searchRequest.projectId = this.globalService.projectId;
    searchRequest.jgSectionId = this.mainRequest.jgSectionId;
    searchRequest.sectionId = this.mainRequest.sectionId;
    Object.assign(searchRequest, data);
    this.searchRequest = searchRequest;
  }

  searchClick(data: any) {
    this.prepareSearch(data);
    this.searchRecord();
  }

  initConfig(fbList: JgVisualInspUnitFb[]) {
    const dwTypeOptions = Array.from(
      new Set(fbList.map((fb) => fb.dwTypeName)),
    ).map((dwTypeName) => {
      return { label: dwTypeName!, value: dwTypeName! };
    });

    const dwOptions = Array.from(
      new Set(fbList.map((fb) => fb.dwCode! + ' ' + fb.dwName!)),
    )
      .map((result) => {
        return { label: result, value: result.split(' ')[0] };
      })
      .sort((a, b) => {
        return a.value.localeCompare(b.value);
      });
    const columns: TableColumnConfig[] = [
      {
        name: '单位工程类型',
        key: 'dwTypeName',
        type: TableColumnType.options,
        options: dwTypeOptions,
        width: 120,
        queryable: true,
        queryKey: 'dwTypeName',
      },
      {
        name: '单位工程',
        key: 'dwCode',
        type: TableColumnType.options,
        width: 200,
        queryable: true,
        queryKey: 'dwCode',
        options: dwOptions,
        sortable: true,
        sortKey: 'dwCodeSortOrder',
        sortDefault: OrderType.ASC,
        sortOrder: 1,
      },
      {
        name: '里程桩号',
        key: 'dwMileage',
        type: TableColumnType.text,
        width: 200,
        queryable: true,
        queryKey: 'dwMileage',
      },
      {
        name: '终检扣分<br/>合计',
        key: 'finalSum',
        type: TableColumnType.text,
        width: 80,
      },
      {
        name: '交工分部',
        key: 'jgFbName',
        type: TableColumnType.text,
        width: 120,
        queryable: true,
        queryKey: 'jgFbName',
      },
      {
        name: '初检扣分',
        key: 'initScore',
        type: TableColumnType.text,
        width: 80,
        align: 'right',
      },
      {
        name: '整改后<br/>终检扣分',
        key: 'finalScore',
        type: TableColumnType.text,
        width: 80,
        align: 'right',
      },
      {
        name: '备注',
        key: 'comment',
        type: TableColumnType.text,
        width: 600,
      },
    ];

    this.config = {
      hasIndex: true,
      columns,
      headerSize: 12,
      bodySize: 13,
    };

    this.totalWidth = columns.reduce((acc, cur) => acc + cur.width, 56);

    this.resetSearch();

    this.getReportList();
  }

  onScroll(event: any) {
    if (this.recordFakeTable.length > 0) {
      this.recordFakeTable = [];
    }
  }

  view(index: number) {
    const id = this.reportList[index].id;
    const query = window.location.href.split('?')[1] ?? '';
    const params = new URLSearchParams(query);
    if (location.href.indexOf('#/open/') > -1) {
      this.openInTab(
        `#/open/entity/view-report-appear/${id}?token=${params.get('token')}&writeable=${params.get('writeable')}`,
      );
    } else {
      this.openInTab(`#/entity/view-report-appear/${id}`);
    }
    // window.open(
    //   environment.fileHost + report.fileId + this.withToken,
    //   '_blank',
    // );
    // const results = this.modalService.open({
    //   backdropCloseable: false,
    //   component: FilePreviewComponent,
    //   onClose: () => {},
    //   data: {
    //     fileList: this.reportList.map((r) => r.fileId!),
    //     previewType: FilePreviewType.PDF,
    //     screenType: ViewScreenType.FullScreen,
    //     index: index,
    //     cantReplace: true,
    //     onDismiss: () => {
    //       results.modalInstance.hide();
    //     },
    //     onFileChange: (fileList: string[]) => {
    //       const removeReportsReq = this.reportList
    //         .filter((r) => !fileList.includes(r.fileId!))
    //         .map((r) => this.jgVisualInspReportFileService.remove(r.id!));
    //       zip(removeReportsReq).subscribe(() => {
    //         this.getReportList();
    //         this.resetSearch();
    //       });
    //     },
    //   },
    // });
  }

  private openInTab(url: string) {
    const target = window.open(url, '_blank');
    setTimeout(() => {
      target?.postMessage({
        type: 'redir',
        data: window.location.href,
      });
    }, 1000);
    // target?.postMessage('redir', window.location.href);
  }

  onScrollEnd($event?: any) {
    const startIndex = Math.floor(this.scroll?.nativeElement.scrollTop / 40);
    const viewportHeight =
      this.scroll?.nativeElement.clientHeight - (this.isOpen ? 120 : 80);
    let endIndex = Math.ceil(viewportHeight / 40) + startIndex;
    if (endIndex > this.recordList.length - 1) {
      endIndex = this.recordList.length - 1;
    }
    const offset = this.scroll?.nativeElement.scrollTop % 40;
    this.scrollTop = this.scroll?.nativeElement.scrollTop - offset;
    this.scrollIndex = startIndex;

    this.recordFakeTable = this.handleTable(
      JSON.parse(
        JSON.stringify(this.recordList.slice(startIndex, endIndex + 1)),
      ),
    );
  }
  private handleTable(recordTable: JgVisualInspUnitFbDetail[]) {
    if (recordTable.length === 0) {
      return [];
    }
    let index = recordTable.length - 1;
    while (index > 0) {
      if (recordTable[index].dwTypeName === recordTable[index - 1].dwTypeName) {
        recordTable[index].dwTypeName = '';
        recordTable[index - 1].dwTypeSpan = !!recordTable[index].dwTypeSpan
          ? recordTable[index].dwTypeSpan! + 1
          : 2;
        if (recordTable[index].dwCode === recordTable[index - 1].dwCode) {
          recordTable[index].dwCode = '';
          recordTable[index - 1].dwCodeSpan = recordTable[index].dwCodeSpan
            ? recordTable[index].dwCodeSpan! + 1
            : 2;
        }
      }
      index--;
    }
    return recordTable;
  }

  pageIndexChange(index: number) {
    this.pager.pageIndex = index;
    this.searchRecord();
  }

  pageSizeChange(size: number) {
    this.pager.pageSize = size;
    this.pager.pageIndex = 1;
    this.searchRecord();
  }

  editing: any = {};

  edit(key: string) {
    this.editing[key] = true;
    console.log(this.editing);
  }

  onBlur(id: number, key: string, value: string) {
    this.editing = {};
    const item = this.recordFakeTable.find((r) => r.id === id);
    if (key === 'dwMileage') {
      this.projectSectionItemService
        .updateDwMileage({
          dwSectionItemId: item?.dwSectionItemId,
          dwMileage: value,
        })
        .subscribe(() => {
          for (const item of this.recordList) {
            if (item.id === id) {
              item.dwMileage = value;
            }
          }
          for (const item of this.recordTable) {
            if (item.id === id) {
              item.dwMileage = value;
            }
          }
          for (const item of this.recordFakeTable) {
            if (item.id === id) {
              item.dwMileage = value;
            }
          }
          this.calculateFinalSum();
        });
    } else {
      this.jgVisualInspUnitFbService
        .update({
          id,
          comment: item?.comment,
          initScore: !!item?.initScore ? item?.initScore : 0,
          finalScore: !!item?.finalScore ? item?.finalScore : 0,
        })
        .subscribe(() => {
          for (const item of this.recordList) {
            if (item.id === id) {
              if (key === 'initScore' || key === 'finalScore') {
                item![key] = value ? parseInt(value) : 0;
              } else {
                item![key] = value;
              }
            }
          }
          for (const item of this.recordTable) {
            if (item.id === id) {
              if (key === 'initScore' || key === 'finalScore') {
                item![key] = value ? parseInt(value) : 0;
              } else {
                item![key] = value;
              }
            }
          }
          for (const item of this.recordFakeTable) {
            if (item.id === id) {
              if (key === 'initScore' || key === 'finalScore') {
                item![key] = value ? parseInt(value) : 0;
              } else {
                item![key] = value;
              }
            }
          }
          this.calculateFinalSum();
        });
    }
  }

  calculateFinalSum() {
    let sum = 0;
    for (const item of this.recordList) {
      sum += item.finalScore ?? 0;
    }
    this.totalSum = sum;

    const totalSumMap: { [key: string]: number } = {};
    for (const item of this.recordList) {
      if (!totalSumMap[item.dwType! + item.dwCode!]) {
        totalSumMap[item.dwType! + item.dwCode!] = 0;
      }
      totalSumMap[item.dwType! + item.dwCode!] += item.finalScore ?? 0;
    }
    console.log('totalSumMap', totalSumMap);
    this.totalSumMap = totalSumMap;
  }
}
